import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export default function PhilosophySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      ref={ref}
      className="bg-[#EFEAE6] py-20 md:py-36 px-6 md:px-16 lg:px-24"
    >
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <span className="label-text" data-testid="philosophy-label">Our Philosophy</span>
          <div className="editorial-line mt-4 mb-12 md:mb-16" />

          <p className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-[1.4] tracking-tight text-[#0A0A0A]">
            At CinCin, we believe the most meaningful celebrations are not the loudest, but the most intentional.
          </p>

          <p className="mt-10 md:mt-14 font-light text-sm sm:text-base leading-[1.8] text-[#0A0A0A]/70 max-w-[640px]">
            Every space, every detail, every moment is designed with purpose.
          </p>

          <div className="mt-6 md:mt-8 space-y-1">
            <p className="font-serif text-lg sm:text-xl italic text-[#0A0A0A]/55 leading-[1.4]">
              Not to impress.
            </p>
            <p className="font-serif text-lg sm:text-xl italic text-[#0A0A0A]/55 leading-[1.4]">
              But to stay with you.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
